import { render, staticRenderFns } from "./PreviewStudents.vue?vue&type=template&id=4eec9b46"
import script from "./PreviewStudents.vue?vue&type=script&lang=js"
export * from "./PreviewStudents.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports